/* Greenic Produktseite (Stand 15.10.2026). Vorlage: ueber-uns/pdp-vorschau (buy_block.py, gen_vorschau.py, set_block.py).
   Geladen mit defer aus sections/main-product.liquid. Teile:
   1 Versandzeile: einmaliges Aufklappen beim ersten Sichtkontakt (nur außerhalb des Glasblocks, dort steht sie statisch)
   2 Kaufleiste mit Blatt (nur unter 768 px): erscheint, wenn der Warenkorb-Button oben aus dem Bild ist; das Blatt zeigt dieselbe
     Kaufauswahl (die Glas-Kachel wird ins Blatt verschoben und danach zurückgestellt), Bestätigen = Submit des Hauptformulars;
     seit 15.10. zeigt die Leiste im Abo auch die Menge je Lieferung ("Abo · 2 Stück · 59,83 €", Preise aus der Kaufauswahl v15)
   3 Über uns: Punkte unter dem Kachel-Slider
   4 Set-Block (Rebuy Bundle Builder als Motor)
   5 Akkordeons G2: Höhen und Scroll in einer Schleife, angetippte Zeile bleibt unter dem Finger (ersetzt seit 15.10. das Festhalten per scrollBy)
   6 Sprung-Button zurück zum Kaufbereich
   7 Sheets Teilen und Frag uns direkt (Stufe 3; der Newsletter läuft über assets/greenic-newsletter.js, weil der Footer-Block überall steht)
   8 Blätter per Wischen nach unten schließen (alle Sheets und das Blatt der Kaufleiste, nur unter 768 px)
   9 Sofort öffnen beim Hinzufügen (18.10.2026, zu greenic-progressbar.liquid v17.2 TEIL P): der Tipp auf "In den Warenkorb" im Kaufbereich,
     im Kaufleisten-Blatt und im Set-Block meldet sich synchron mit dem Ereignis greenic:add-start (Produkt, Bild, Menge, Preis aus der
     Kaufauswahl); der Warenkorb öffnet dann sofort mit einer Platzhalter-Zeile, statt rund eine Sekunde auf die Antwort zu warten.
   Zustand der Kaufauswahl: window.GreenicBuy (snippets/product-bundle-selector-clean.liquid). */
(function () {
  'use strict';
  var doc = document;
  var calm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1 Versandzeile ---------- */
  function initShip() {
    var els = doc.querySelectorAll('[data-gx-ship].is-armed');
    if (!els.length || !('IntersectionObserver' in window) || calm) {
      doc.querySelectorAll('[data-gx-ship]').forEach(function (e) { e.classList.remove('is-armed'); });
      return;
    }
    els.forEach(function (st) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { io.disconnect(); setTimeout(function () { st.classList.add('is-in'); }, 350); }
        });
      }, { threshold: 0.9 });
      io.observe(st);
    });
  }

  /* ---------- Geld ---------- */
  function money(cents) {
    try {
      if (window.FoxTheme && FoxTheme.Currency && FoxTheme.settings && FoxTheme.settings.moneyFormat) {
        return FoxTheme.Currency.formatMoney(cents, FoxTheme.settings.moneyFormat);
      }
    } catch (e) {}
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* ---------- 9 Sofort öffnen beim Hinzufügen (v17.2) ----------
     Das Hauptformular wird von Sleeks product-form per fetch abgeschickt. Ein Listener in der Capture-Phase am Dokument läuft vor dem des
     Themes; er meldet den Tipp mit den Daten der Kaufauswahl (window.GreenicBuy), bevor die Anfrage /cart/add startet. Das Kaufleisten-Blatt
     schickt über requestSubmit, das Ereignis kommt synchron, blattQuelle sagt woher. Der Set-Block meldet selbst (Teil 4). */
  var blattQuelle = false;
  function melde(d) { try { doc.dispatchEvent(new CustomEvent('greenic:add-start', { detail: d })); } catch (e) {} }
  function bildGross(u) { return String(u || '').replace(/([?&])(width|height)=\d+/g, '$1$2=192'); }
  function kaufDetail(form, quelle) {
    var vEl = form.querySelector('[name="id"]'), vid = vEl ? String(vEl.value || '') : '';
    if (!vid) return null;
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product, v = null;
    if (meta && meta.variants) for (var i = 0; i < meta.variants.length; i++) if (String(meta.variants[i].id) === vid) v = meta.variants[i];
    var h1 = doc.querySelector('h1'), titel = (v && v.name) || (h1 ? h1.textContent.replace(/\s+/g, ' ').trim() : '');
    var im = doc.querySelector('#GreenicStickyBuy .gxsb__bar img'), og = doc.querySelector('meta[property="og:image"]');
    var bild = im ? bildGross(im.getAttribute('src') || '') : (og ? og.getAttribute('content') || '' : '');
    var buy = window.GreenicBuy, st = buy && buy.getState ? buy.getState() : null, abo = !!(st && st.mode === 'abo');
    var qEl = form.querySelector('[name="quantity"]');
    var menge = st ? (abo ? (st.aq || 1) : (st.q || 1)) : (qEl ? parseInt(qEl.value, 10) || 1 : 1);
    var preis = '';
    if (buy && st) {
      if (abo) preis = typeof buy.aboTotalFormatted === 'function' ? buy.aboTotalFormatted() : (buy.aboPriceFormatted || '');
      else if (menge === 1) preis = buy.basePriceFormatted || (typeof buy.priceFormatted === 'function' ? buy.priceFormatted() : '');
      else { var base = buy.basePrice || 0, pr = (buy.tiers && buy.tiers[menge]) || 0, gross = base * menge; preis = money(gross - Math.round(gross * pr / 100)); }
    } else if (v && v.price) preis = money(v.price * menge);
    return { quelle: quelle, items: [{ id: vid, titel: titel, bild: bild, menge: menge, preis: preis, abo: abo && st.planLabel ? 'Alle ' + st.planLabel : '' }] };
  }
  function initSofort() {
    if (doc.__gxSofort) return;
    doc.__gxSofort = true;
    doc.addEventListener('submit', function (e) {
      var f = e.target, q = blattQuelle;
      blattQuelle = false;
      if (!f || !f.matches || !f.matches('form.main-product-form')) return;
      var d = null;
      try { d = kaufDetail(f, q ? 'blatt' : 'kaufbereich'); } catch (x) { d = null; }
      if (d) melde(d);
    }, true);
  }

  /* ---------- 2 Kaufleiste mit Blatt ---------- */
  function initSticky() {
    var root = doc.getElementById('GreenicStickyBuy');
    if (!root || root.__gxInit) return;
    root.__gxInit = true;
    var bar = root.querySelector('.gxsb__bar'), sheet = root.querySelector('.gxsb__sheet'), dim = root.querySelector('.gxsb-dim');
    var openBtn = root.querySelector('[data-gxsb-open]'), closeBtn = root.querySelector('.gxsb__close');
    var confirmBtn = root.querySelector('[data-gxsb-confirm]'), slot = root.querySelector('[data-gxsb-slot]');
    var priceEl = root.querySelector('.gxsb__price');
    var form = doc.querySelector('product-info form.main-product-form') || doc.querySelector('form.main-product-form');
    var atc = form ? form.querySelector('[type="submit"]') : null;
    var header = doc.querySelector('.header-section') || doc.querySelector('.shopify-section-group-header-group');
    var soldOut = root.getAttribute('data-sold-out') === 'true';
    var textOnce = root.getAttribute('data-text-once') || 'In den Warenkorb';
    var textAbo = root.getAttribute('data-text-abo') || 'Abo starten';
    var textSold = root.getAttribute('data-text-sold') || 'Ausverkauft';
    var buy = window.GreenicBuy || null;
    var placeholder = null, lastFocus = null, isOpen = false;

    if (!form || !atc) { root.remove(); return; }

    function total() {
      if (!buy) return null;
      var s = buy.getState();
      if (s.mode === 'abo') return null;
      var q = s.q || 1, base = buy.basePrice || 0, p = (buy.tiers && buy.tiers[q]) || 0;
      var gross = base * q;
      return gross - Math.round(gross * p / 100);
    }
    function aboTotal() {
      if (!buy) return '';
      if (typeof buy.aboTotalFormatted === 'function') return buy.aboTotalFormatted();
      return buy.aboPriceFormatted || buy.priceFormatted();
    }
    function label() {
      if (!buy) return priceEl.getAttribute('data-initial') || '';
      var s = buy.getState();
      if (s.mode === 'abo') return 'Abo · ' + ((s.aq || 1) > 1 ? s.aq + ' Stück · ' : '') + aboTotal();
      if (s.q === 1) return buy.basePriceFormatted || buy.priceFormatted();
      return s.q + ' Stück · ' + money(total());
    }
    function render() {
      if (soldOut) { priceEl.textContent = priceEl.getAttribute('data-initial') || ''; openBtn.textContent = textSold; openBtn.disabled = true; return; }
      priceEl.textContent = label();
      if (buy) {
        var s = buy.getState();
        confirmBtn.textContent = (s.mode === 'abo' ? textAbo : textOnce) + ' · ' + (s.mode === 'abo' ? aboTotal() : money(total()));
      }
    }
    function check() {
      if (!doc.body.contains(atc)) return;
      var hb = header ? header.getBoundingClientRect().bottom : 0;
      var past = atc.getBoundingClientRect().bottom < Math.max(hb, 0);
      if (!past && isOpen) close();
      root.classList.toggle('is-on', past);
      bar.setAttribute('aria-hidden', past ? 'false' : 'true');
      doc.body.classList.toggle('gxsb-visible', past);
    }
    function open() {
      if (soldOut) return;
      if (!buy || !buy.root) { submit(); return; }   // ohne Kaufauswahl (Bundles): direkt in den Warenkorb
      if (isOpen) return;
      isOpen = true; lastFocus = doc.activeElement;
      if (!placeholder) { placeholder = doc.createComment('gxk'); buy.root.parentNode.insertBefore(placeholder, buy.root); }
      slot.appendChild(buy.root);
      sheet.classList.add('is-open'); sheet.setAttribute('aria-hidden', 'false');
      dim.classList.add('is-on'); doc.body.classList.add('gxsb-sheet');
      var f = sheet.querySelector('.gxk__seg[aria-selected="true"], .gxk__tile.is-on, button');
      setTimeout(function () { if (f) try { f.focus({ preventScroll: true }); } catch (e) {} }, 60);
    }
    function close() {
      if (!isOpen) return;
      isOpen = false;
      sheet.classList.remove('is-open'); sheet.setAttribute('aria-hidden', 'true');
      dim.classList.remove('is-on'); doc.body.classList.remove('gxsb-sheet');
      if (placeholder && placeholder.parentNode && buy && buy.root) placeholder.parentNode.insertBefore(buy.root, placeholder);
      if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
    function submit() {
      if (atc.disabled) return;
      try { form.requestSubmit(atc); } catch (e) { atc.click(); }
    }
    openBtn.addEventListener('click', open);
    closeBtn.addEventListener('click', close);
    dim.addEventListener('click', close);
    confirmBtn.addEventListener('click', function () { close(); blattQuelle = true; submit(); blattQuelle = false; });   // v17.2: Teil 9, Blatt zu und Warenkorb auf im selben Moment
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    if (buy) buy.subscribe(render);
    doc.addEventListener('greenic:buy-ready', function (e) { if (buy) return; buy = e.detail || window.GreenicBuy; if (buy) buy.subscribe(render); render(); });

    // Menü offen: Leiste weg (Body-Klasse, weil CSS den Zustand des Drawers nicht sehen kann)
    var menu = doc.getElementById('MenuDrawer') || doc.querySelector('menu-drawer');
    if (menu && 'MutationObserver' in window) {
      var mo = new MutationObserver(function () { doc.body.classList.toggle('gxsb-menu', menu.hasAttribute('open')); });
      mo.observe(menu, { attributes: true, attributeFilter: ['open'] });
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    doc.addEventListener('rebuy:smartcart.show', close);
    render(); check();
  }

  /* ---------- 3 Über uns: Punkte unter dem Slider ---------- */
  function initAbout() {
    doc.querySelectorAll('[data-gx-about]').forEach(function (s) {
      if (s.__gxInit) return; s.__gxInit = true;
      var t = s.querySelector('.gxp__track'), d = s.querySelector('.gxp__dots');
      if (!t || !d) return;
      var c = [].slice.call(t.querySelectorAll('.gxp__card'));
      if (c.length < 2) { d.hidden = true; return; }
      var pad = parseFloat(getComputedStyle(t).paddingLeft) || 0;
      c.forEach(function (card, i) {
        var b = doc.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Kachel ' + (i + 1));
        b.addEventListener('click', function () { t.scrollTo({ left: card.offsetLeft - pad, behavior: calm ? 'auto' : 'smooth' }); });
        d.appendChild(b);
      });
      function upd() {
        var best = 0, bd = 1e9;
        if (t.scrollLeft + t.clientWidth >= t.scrollWidth - 4) { best = c.length - 1; }
        else { c.forEach(function (card, i) { var x = Math.abs(card.offsetLeft - pad - t.scrollLeft); if (x < bd) { bd = x; best = i; } }); }
        for (var j = 0; j < d.children.length; j++) d.children[j].setAttribute('aria-current', j === best ? 'true' : 'false');
      }
      t.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
      upd();
    });
  }


  /* ---------- 4 Set-Block (sections/greenic-pdp-set.liquid): Rebuy Bundle Builder als Motor, eigene Oberfläche ---------- */
  function initSet() {
    var root = doc.querySelector('[data-gx-set]');
    if (!root || root.__gxInit) return;
    root.__gxInit = true;
    var builderId = root.getAttribute('data-builder-id'), dsId = root.getAttribute('data-ds-id');
    var PAGE = { id: root.getAttribute('data-product-id'), variantId: root.getAttribute('data-variant-id'), price: parseInt(root.getAttribute('data-price'), 10) || 0,
                 title: root.getAttribute('data-title'), handle: root.getAttribute('data-handle'), image: root.getAttribute('data-image'), unit: root.getAttribute('data-unit') || '' };
    var TIERS; try { TIERS = JSON.parse(root.getAttribute('data-tiers')); } catch (e) { TIERS = [[3, 5], [4, 10]]; }
    var MIN = parseInt(root.getAttribute('data-min'), 10) || 3, MAX = parseInt(root.getAttribute('data-max'), 10) || 4, N = parseInt(root.getAttribute('data-suggestions'), 10) || 5;
    var TXT_BTN = root.getAttribute('data-text-btn') || 'In den Warenkorb', TXT_MIN = root.getAttribute('data-text-min') || 'Ab 3 Produkten';
    var track = root.querySelector('.gxs__track'), rail = root.querySelector('.gxs__rail'), slots = [].slice.call(root.querySelectorAll('.gxs__slot'));
    var msg = root.querySelector('.gxs__msg'), btn = root.querySelector('.gxs__btn'), toast = root.querySelector('.gxs__toast');
    var oldEl = root.querySelector('.gxs__total s'), nowEl = root.querySelector('.gxs__total strong'), saveEl = root.querySelector('.gxs__save');
    var bar = root.querySelector('.gxs__bar i'), fx = root.querySelector('.gxs__fx');
    var X = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 7l10 10M17 7L7 17"/></svg>';
    var PLUS = '<svg class="i-plus" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 6v12M6 12h12"/></svg>';
    var CHECK = '<svg class="i-check" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 12.5l4 4 8-9"/></svg>';
    var W = null, V = null, STEP = null, pool = {}, picked = [], lastP = 0, shown = PAGE.price, busy = false, unitCache = {}, sugCache = {};
    var tt, snapT, page = 0, moreCard = null, reqSeq = 0;

    function esc(x) { return String(x == null ? '' : x).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
    function cents(p) {
      if (p == null) return 0;
      if (typeof p === 'number') return p > 999 || Number.isInteger(p) ? Math.round(p) : Math.round(p * 100);
      var str = String(p); return str.indexOf('.') >= 0 ? Math.round(parseFloat(str) * 100) : (parseInt(str, 10) || 0);
    }
    function pct(n) { var p = 0; TIERS.forEach(function (t) { if (n >= t[0]) p = t[1]; }); return p; }
    function pid(x) { return String(x && (x.id != null ? x.id : x)); }
    function imgOf(prod) {
      var im = prod.image || (prod.images && prod.images[0]) || (prod.featured_image) || '';
      var src = typeof im === 'string' ? im : (im && (im.src || im.url || im.original_src)) || '';
      if (src && /cdn\.shopify\.com/.test(src) && !/[?&]width=/.test(src)) src += (src.indexOf('?') >= 0 ? '&' : '?') + 'width=228';   /* 15.10.: 3x der Kachel (76 px) */
      return src;
    }
    function priceOf(prod) { var v = prod.selected_variant || (prod.variants && prod.variants[0]) || {}; return cents(v.price); }
    function poolItem(id) { return pool[pid(id)] || null; }

    /* Rebuy-Wahrheit: Produkte im Bundle (IDs) */
    function bundleIds() { try { return (W.data.products || []).map(function (p) { return pid(p.id || (p.product && p.product.id)); }); } catch (e) { return []; } }

    /* Vorschläge aus der Warenkorb-Sortierung (DS 312610): simulierter Warenkorb = Seitenprodukt plus Bundle */
    function suggest(ids) {
      var key = ids.slice().sort().join(',');
      if (sugCache[key]) return sugCache[key];
      var R = window.Rebuy, apiKey = R && R.shop && R.shop.api_key;
      if (!apiKey) return Promise.resolve([]);
      var q = new URLSearchParams();
      q.set('key', apiKey); q.set('limit', '24'); q.set('shopify_product_ids', PAGE.id);
      var items = [PAGE.id].concat(ids.filter(function (i) { return i !== PAGE.id; }));
      items.forEach(function (id, i) {
        var pp = poolItem(id) || {}; var vid = id === PAGE.id ? PAGE.variantId : ((pp.selected_variant && pp.selected_variant.id) || (pp.variants && pp.variants[0] && pp.variants[0].id) || '');
        q.set('cart[items][' + i + '][product_id]', id); q.set('cart[items][' + i + '][variant_id]', String(vid)); q.set('cart[items][' + i + '][quantity]', '1');
      });
      q.set('cart[line_count]', String(items.length)); q.set('cart[item_count]', String(items.length));
      q.set('cart_count', String(items.length)); q.set('cart_line_count', String(items.length)); q.set('cart_item_count', String(items.length));
      var pr = fetch('https://rebuyengine.com/api/v1/custom/id/' + encodeURIComponent(dsId) + '?' + q.toString(), { credentials: 'omit' })
        .then(function (r) { return r.json(); })
        .then(function (j) { return ((j && j.data) || []).map(function (p) { return pid(p.id); }); })
        .catch(function () { return []; });
      sugCache[key] = pr;
      return pr;
    }
    function unitFor(prod, el) {
      var h = prod.handle; if (!h) return;
      if (unitCache[h]) { el.textContent = unitCache[h]; return; }
      fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).then(function (j) {
        var v = j && j.variants && j.variants[0];
        if (v && v.unit_price && v.unit_price_measurement && v.unit_price_measurement.reference_unit) {
          unitCache[h] = money(cents(v.unit_price)) + '/' + v.unit_price_measurement.reference_unit; el.textContent = unitCache[h];
        }
      }).catch(function () {});
    }

    /* 13.10. 16:50 (Constantin): Titel wie im Rebuy-Warenkorb kürzen (snippets/greenic-progressbar.liquid, splitTitle v8):
       Name = Teil vor dem ersten Komma, darunter grau Grammatur und Rest ("Bio Flora" / "126g · Präbiotika & Probiotika") */
    var GRAM = /[\s,]*(\d+(?:[.,]\d+)?\s*(?:g|kg|ml|l))\s*$/i;
    function splitTitle(t) {
      t = String(t || '').trim(); var gram = '', m = t.match(GRAM);
      if (m) { gram = m[1].replace(/\s+/g, ''); t = t.slice(0, t.length - m[0].length); }
      t = t.replace(/[\s,]+$/, '');
      var name = t, rest = '', k = t.indexOf(',');
      if (k > -1) { name = t.slice(0, k); rest = t.slice(k + 1); }
      name = name.replace(/^[\s,]+|[\s,]+$/g, '');
      rest = rest.replace(/^[\s,]+|[\s,]+$/g, '').replace(/^(Bio|mit|fuer|für|der|die|das)\s+/i, '');
      /* 13.10. 17:00 (Constantin): Markentitel ("Wellora, Kreatin Pulver, 450g"): Art hinter die Marke, "Wellora Kreatin", Zusatzzeile bleibt "450g · Kreatin Pulver" */
      if (rest && /^wellora$/i.test(name)) { var art = rest.split(/\s+/)[0]; if (art) name = name + ' ' + art; }
      var sub = gram && rest ? (gram + ' · ' + rest) : (gram || rest);
      return { name: name || t, sub: sub };
    }
    function card(prod) {
      var li = doc.createElement('li'); li.className = 'gxs__card'; li.setAttribute('data-key', pid(prod.id));
      var tt = splitTitle(prod.title);
      li.innerHTML = '<button type="button" class="gxs__hit" aria-label="' + esc(prod.title) + ' zum Bundle hinzufügen"></button>' +
        '<img class="gxs__img" src="' + esc(imgOf(prod)) + '" width="76" height="76" alt="" loading="lazy">' +
        '<span class="gxs__name">' + esc(tt.name) + '</span><span class="gxs__sub">' + esc(tt.sub) + '</span><span class="gxs__price">' + money(priceOf(prod)) + '</span>' +
        '<span class="gxs__base"></span><span class="gxs__add" aria-hidden="true">' + PLUS + CHECK + '</span>';
      unitFor(prod, li.querySelector('.gxs__base'));
      li.querySelector('.gxs__hit').addEventListener('click', function () { add(pid(prod.id), li); });
      return li;
    }
    function leave(li, instant) {
      var l = li.offsetLeft, t = li.offsetTop;
      if (instant || calm) { li.remove(); return; }
      li.style.left = l + 'px'; li.style.top = t + 'px'; li.classList.add('is-leaving');
      setTimeout(function () { li.remove(); }, 320);
    }
    /* Produkte, die in der Reihe erscheinen dürfen: im Pool, nicht das Seitenprodukt, nicht im Bundle, keine Probierbeutel (30 g) */
    function allowed(k, ids) {
      var p = poolItem(k); if (!p || k === PAGE.id || ids.indexOf(k) >= 0) return false;
      var h = String(p.handle || ''), t = String(p.title || '');
      if (/probierbeutel|probe/i.test(h) || /\b30\s?g\b/i.test(t)) return false;
      return true;
    }
    /* Reihenfolge aller Kandidaten: erst die Warenkorb-Sortierung (DS 312610), dann der Rest des Pools */
    function candidates(ids) {
      return suggest(ids).then(function (list) {
        var out = [];
        list.forEach(function (k) { if (allowed(k, ids) && out.indexOf(k) < 0) out.push(k); });
        Object.keys(pool).forEach(function (k) { if (allowed(k, ids) && out.indexOf(k) < 0) out.push(k); });
        return out;
      });
    }
    function ensureMoreCard() {
      if (moreCard) return moreCard;
      var li = doc.createElement('li'); li.className = 'gxs__card gxs__card--more'; li.setAttribute('data-key', '__more');
      li.innerHTML = '<button type="button" class="gxs__hit" aria-label="Andere Vorschläge zeigen"></button>' +
        '<span class="gxs__more-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M20 12a8 8 0 1 1-2.3-5.6"/><path d="M20 4v5h-5"/></svg></span>' +
        '<span class="gxs__more-t">Andere Vorschläge</span><span class="gxs__more-s"></span>';
      li.querySelector('.gxs__hit').addEventListener('click', function () { if (busy) return; page += 1; reconcile(null, true); });
      moreCard = li; return li;
    }
    function reconcile(gone, flip) {
      var ids = picked.slice(), seq = ++reqSeq;
      root.classList.add('is-loading');
      candidates(ids).then(function (list) {
        if (seq !== reqSeq) return;   // eine neuere Abfrage läuft schon
        root.classList.remove('is-loading');
        var total = list.length;
        if (page * N >= total) page = 0;
        var start = page * N, want = list.slice(start, start + N), rest = total - start - want.length;   /* 13.10. 16:35: "Noch n" zählt runter, letzte Seite zeigt den Rest */
        var keepLeft = rail.scrollLeft; rail.style.scrollSnapType = 'none'; clearTimeout(snapT);
        var kids = [].slice.call(track.children).filter(function (li) { return !li.classList.contains('is-leaving') && li !== moreCard; });
        var by = {}, first = {};
        kids.forEach(function (li) { var k = li.getAttribute('data-key'); by[k] = li; first[k] = li.getBoundingClientRect().left; });
        kids.forEach(function (li) { var k = li.getAttribute('data-key'); if (want.indexOf(k) < 0) leave(li, k === gone); });
        var fresh = [];
        want.forEach(function (k) { var el = by[k]; if (!el) { el = card(poolItem(k)); if (!calm && kids.length) el.classList.add('is-new'); fresh.push(el); } track.appendChild(el); });
        if (total > want.length) {
          var mc = ensureMoreCard();
          mc.querySelector('.gxs__more-s').textContent = rest > 0 ? ('Noch ' + rest + ' Produkt' + (rest === 1 ? '' : 'e')) : 'Wieder von vorn';
          track.appendChild(mc);
        } else if (moreCard && moreCard.parentNode) { moreCard.remove(); }
        rail.scrollLeft = keepLeft;
        if (kids.length && (keepLeft > 0 || flip)) rail.scrollTo({ left: 0, behavior: calm ? 'auto' : 'smooth' });
        snapT = setTimeout(function () { rail.style.scrollSnapType = ''; }, 800);
        root.classList.add('is-ready');
        if (!calm) {
          want.forEach(function (k) { var el = by[k]; if (!el) return; var dx = first[k] - el.getBoundingClientRect().left;
            if (Math.abs(dx) > 1) { el.style.transition = 'none'; el.style.transform = 'translateX(' + dx + 'px)'; void el.offsetWidth;
              el.style.transition = 'transform .5s cubic-bezier(.3,.7,.4,1)'; el.style.transform = ''; setTimeout(function () { el.style.transition = ''; }, 540); } });
          fresh.forEach(function (el, i) { if (!el.classList.contains('is-new')) return; el.style.animationDelay = (120 + 70 * i) + 'ms'; setTimeout(function () { el.classList.remove('is-new'); el.style.animationDelay = ''; }, 900); });
        }
        // die nächsten Zustände vorladen (ein Tipp auf eine sichtbare Kachel)
        if (picked.length < MAX - 1) want.forEach(function (k) { suggest(ids.concat([k])); });
      });
    }
    function countTo(v) {
      if (calm) { shown = v; nowEl.textContent = money(v); return; }
      var from = shown, t0 = performance.now(), d = 420;
      (function step(t) { var q = Math.min(1, (t - t0) / d), e = 1 - Math.pow(1 - q, 3); nowEl.textContent = money(Math.round(from + (v - from) * e)); if (q < 1) requestAnimationFrame(step); else shown = v; })(t0);
    }
    function burst(big) {
      if (calm) return;
      var base = root.getBoundingClientRect(), s = slots[big ? 3 : 2].getBoundingClientRect();
      var x = s.left + s.width / 2 - base.left, y = s.top - base.top, cols = ['#009253', '#007a45', '#2fa36b', '#5cbf8c', '#9bd8b5', '#c9ecd8', '#0f5c3a'];
      for (var i = 0; i < (big ? 26 : 16); i++) {
        var b = doc.createElement('b'), a = Math.random() * Math.PI * 2, dist = 40 + Math.random() * (big ? 90 : 60);
        b.style.left = x + 'px'; b.style.top = y + 'px'; b.style.background = cols[i % cols.length];
        b.style.setProperty('--dx', Math.cos(a) * dist + 'px'); b.style.setProperty('--dy', (Math.sin(a) * dist - 30) + 'px'); b.style.setProperty('--r', (Math.random() * 540 - 270) + 'deg');
        if (i % 3 === 2) b.style.borderRadius = '50%';
        fx.appendChild(b); setTimeout(function (el) { return function () { el.remove(); }; }(b), 1300);
      }
    }
    function fly(li, slot) {
      var img = li.querySelector('.gxs__img'), a = img.getBoundingClientRect(), target = slot.querySelector('img');
      if (calm || !target) { slot.classList.add('is-pop'); return; }
      slot.classList.add('is-hold');
      var b = target.getBoundingClientRect(), c = img.cloneNode(); c.className = 'gxs__fly';
      c.style.left = a.left + 'px'; c.style.top = a.top + 'px'; c.style.width = a.width + 'px'; c.style.height = a.height + 'px';
      doc.body.appendChild(c);
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        c.style.transformOrigin = '0 0'; c.style.transform = 'translate(' + (b.left - a.left) + 'px,' + (b.top - a.top) + 'px) scale(' + (b.width / a.width) + ')';
      }); });
      setTimeout(function () { c.remove(); slot.classList.remove('is-hold'); slot.classList.remove('is-pop'); void slot.offsetWidth; slot.classList.add('is-pop'); }, 560);
    }
    function say(text) { toast.textContent = text; toast.classList.add('is-on'); clearTimeout(tt); tt = setTimeout(function () { toast.classList.remove('is-on'); }, 2600); }

    /* Rebuy-Aufrufe: ins Bundle legen, entfernen (beide wirken sofort, geprüft 15.10. in der Kopie).
       15.10.2026 (iPhone-Test Constantin, "manchmal lassen sich Produkte nicht ins Bundle legen"): Rebuy speichert das Bundle im Browser
       (localStorage _r_bundle_builder_atc_id_<Builder-ID>) und bringt es auf jeder Produktseite wieder mit, samt den Seitenprodukten früherer
       Seiten. Die Oberfläche zeigte davon nichts. Nach drei besuchten Produktseiten war das Bundle voll (Rebuy-Höchstwert 4): Rebuy nahm nichts
       mehr an (still oder mit Fehler), und der Warenkorb-Knopf hätte die unsichtbaren Produkte mitgeschickt. Deshalb: beim Start räumt purge()
       Rebuy auf die Ausgangslage der Oberfläche (nur das Seitenprodukt), rebuyAdd prüft, ob das Produkt wirklich drin ist, und vor dem Warenkorb
       bringt align() Rebuy exakt auf Seitenprodukt plus Auswahl. */
    /* 15.10.2026, 12:53 (iPhone, Constantin: "reinlegen klappt, Fehlermeldung kommt jedes Mal"): Rebuy legt das Produkt ins Bundle und
       schreibt danach das Bundle in den localStorage. Ist der Speicher der Seite voll, wirft Rebuy dabei einen QuotaExceededError (sein
       LocalStorage.set reicht DOMException durch), obwohl das Produkt schon im Bundle liegt. Gemessen 15.10. in Chrome: der Schlüssel
       stape_events belegt auf greenic-bio.de 2,57 Mio. Zeichen (629 Tracking-Ereignisse seit 02.06., nie geleert); Safari erlaubt rund 5 MB
       je Seite. In der Kopie nachgestellt (Schreibzugriff wirft): Produkt drin plus Fehlerhinweis, genau wie am iPhone.
       Deshalb zählt nicht, ob Rebuy einen Fehler wirft, sondern ob das Produkt danach im Bundle liegt. Beim Entfernen genauso: der Rückfall
       greift nur, wenn der Eintrag wirklich noch da ist (sonst würde er ein zweites Produkt entfernen). */
    function rmAt(i) {
      var before = bundleIds(), k = before[i];
      if (k == null) return;
      try { V.handleRemovingProductFromBundle(i); } catch (e) {}
      var after = bundleIds();
      if (after.length === before.length && after[i] === k) { try { W.data.products.splice(i, 1); } catch (e2) {} }   // Rebuy hat nicht entfernt: selbst raus
    }
    function rebuyAdd(id) {
      var p = poolItem(id), k = pid(id); if (!p || !V) return false;
      if (bundleIds().indexOf(k) > -1) return true;
      try { V.addProductToBundle(p, STEP, 0); } catch (e) {}   // Fehler nach dem Ablegen (voller Speicher) zählt nicht
      return bundleIds().indexOf(k) > -1;
    }
    function rebuyRemove(id) {
      if (!V) return false;
      var ids = bundleIds(), i = ids.indexOf(pid(id));
      if (i < 0) return false;
      rmAt(i); return true;
    }
    /* Rebuy exakt auf Seitenprodukt plus Auswahl bringen: Fremdes und Doppeltes raus (von hinten, damit die Positionen stimmen), Fehlendes rein */
    function align() {
      if (!V) return false;
      var want = [PAGE.id].concat(picked), ids = bundleIds(), i;
      for (i = ids.length - 1; i >= 0; i--) { if (want.indexOf(ids[i]) < 0 || ids.indexOf(ids[i]) !== i) rmAt(i); }
      want.forEach(function (k) { if (bundleIds().indexOf(k) < 0) rebuyAdd(k); });
      ids = bundleIds();
      return ids.length === want.length && want.every(function (k) { return ids.indexOf(k) > -1; });
    }
    function purge() { picked = []; align(); }
    /* 15.10.2026, 13:19 (iPhone, Constantin: "wenn alle Produkte im Bundle sind, friert der Bildschirm ein"): Rebuy klappt bei vollem Bundle
       unter 1200 px Breite seinen eigenen Bundle-Behälter auf (Watcher in ViewBundleBuilder: getRemainingBundleSlots() < 1, dann
       handleExpandingBundleContainer()) und setzt dabei body.rebuy-modal-visible (overflow hidden). Der Behälter ist bei uns unsichtbar
       (leeres Instanz-Template), die Seite blieb gesperrt, auch nach dem Entfernen. In der Kopie nachgestellt (Breite 400 vorgetäuscht).
       Sobald Rebuy die Klasse setzt, klappen wir den Behälter wieder zu; greenic-pdp.css hebt die Sperre zusätzlich sofort auf. */
    function unlock() {
      var b = doc.body;
      if (!b || !b.classList.contains('rebuy-bundle-builder-container-visible')) return;
      try { V.handleExpandingBundleContainer(false); } catch (e) {}
      if (b.classList.contains('rebuy-bundle-builder-container-visible')) b.classList.remove('rebuy-modal-visible', 'rebuy-bundle-builder-container-visible');
      try { if (W && W.data) W.data.has_container_expanded = false; } catch (e2) {}
    }
    function add(k, li) {
      if (busy || picked.indexOf(k) > -1) return;
      if (1 + picked.length >= MAX) { say('Das Set ist voll (' + MAX + ' Produkte). Entferne eins, um zu tauschen.'); return; }
      if (!rebuyAdd(k)) { align(); if (!rebuyAdd(k)) { say('Das hat gerade nicht geklappt. Bitte noch einmal tippen.'); return; } }
      picked.push(k); page = 0; render();
      fly(li, slots[Math.min(picked.length, 3)]);
      reconcile(k);
    }
    function drop(k) {
      var i = picked.indexOf(k); if (i < 0 || busy) return;
      rebuyRemove(k);
      picked.splice(i, 1); page = 0; render(); reconcile(null);
    }
    function ensurePage() { if (bundleIds().indexOf(PAGE.id) < 0) rebuyAdd(PAGE.id); }
    function resetAfterCart() {   // Rebuy leert sein Bundle nach dem Warenkorb-Klick: Oberfläche auf Anfang, Seitenprodukt wieder ins Set
      picked = []; lastP = 0; page = 0; ensurePage(); render(); reconcile(null);
    }
    function syncFromRebuy() {   // Rebuy hat selbst etwas geändert (Events): eigene Liste angleichen
      var all = bundleIds();
      if (!all.length) { resetAfterCart(); return; }
      var ids = all.filter(function (i) { return i !== PAGE.id; });
      var changed = ids.length !== picked.length || ids.some(function (i) { return picked.indexOf(i) < 0; });
      if (changed) { picked = ids.filter(function (i) { return poolItem(i); }); page = 0; render(); reconcile(null); }
    }
    /* 16.10.2026: Bundle-Rabatt je Zeile ABGERUNDET wie die Rebuy-Function im Checkout (19,99 zu 19,00 bei 5%, 34,99 zu 33,25). Vorher Math.round: Anzeige je Zeile 1 Cent zu guenstig (3 Produkte 71,22 statt 71,25). */
    function render() {
      var n = 1 + picked.length, p = pct(n), sum = PAGE.price, disc = Math.floor(PAGE.price * p / 100);
      picked.forEach(function (k) { var c = priceOf(poolItem(k)); sum += c; disc += Math.floor(c * p / 100); });
      slots.forEach(function (s, i) {
        if (i === 0) return;
        var k = picked[i - 1], pctEl = s.querySelector('.gxs__slot-pct'), lab = pctEl ? pctEl.outerHTML : '';
        if (k) {
          var keep = s.getAttribute('data-k') === k, prod = poolItem(k);
          s.className = 'gxs__slot is-filled'; s.setAttribute('data-k', k);
          if (!keep) {
            s.innerHTML = '<img src="' + esc(imgOf(prod)) + '" alt="' + esc(prod.title) + '">' + lab + '<button type="button" class="gxs__x" aria-label="' + esc(prod.title) + ' aus dem Bundle entfernen">' + X + '</button>';
            s.querySelector('.gxs__x').onclick = function (e) { e.stopPropagation(); drop(k); };
          }
        } else { s.className = 'gxs__slot'; s.removeAttribute('data-k'); s.innerHTML = '<span class="gxs__slot-empty">' + PLUS + '</span>' + lab; }
      });
      var nx = slots[Math.min(n, slots.length - 1)]; if (n < MAX && nx && !nx.classList.contains('is-filled')) nx.classList.add('is-next');
      var t1 = TIERS[0] || [MIN, 0], t2 = TIERS[1] || t1;
      if (n < t1[0]) { var rest = t1[0] - n; msg.innerHTML = 'Noch <b>' + rest + ' Produkt' + (rest === 1 ? '' : 'e') + '</b> bis ' + t1[1] + '% Rabatt.'; }
      else if (n < t2[0]) { msg.innerHTML = '<strong>' + t1[1] + '% Rabatt gesichert.</strong><span>Noch ein Produkt und du sparst ' + t2[1] + '%.</span>'; }
      /* 16.10.2026 (Constantin 01:35): Hinweis "Spare weiter mit Mengenrabatt" samt "Was ist das?" entfernt. Bundle- und Mengenrabatt
         addieren sich nicht: Shopify gibt je Warenkorbzeile nur einen Produktrabatt, gezählt wird der höhere (live gemessen 16.10. 01:30). */
      else { msg.innerHTML = '<strong>' + t2[1] + '% Rabatt gesichert.</strong><span>Clever kombiniert.</span>'; }
      bar.style.width = Math.min(n, MAX) / MAX * 100 + '%';
      oldEl.textContent = p ? money(sum) : '';
      countTo(sum - disc);
      saveEl.textContent = p ? '−' + money(disc) : ''; saveEl.classList.toggle('is-on', p > 0);
      btn.disabled = n < MIN;
      btn.textContent = n < MIN ? TXT_MIN : TXT_BTN;
      if (p > lastP) setTimeout(function () { burst(p === (t2[1] || 10)); }, 380);
      lastP = p;
    }
    btn.addEventListener('click', function () {
      if (!V || busy) return;
      if (!align()) { say('Das hat gerade nicht geklappt. Bitte noch einmal versuchen.'); return; }   // 15.10.: nur das, was die Leiste zeigt, geht in den Warenkorb
      busy = true; btn.classList.add('is-busy');
      try { melde(setDetail()); } catch (e1) {}   // v17.2 (Teil 9): Warenkorb sofort auf, Platzhalter je Produkt
      try {
        var r = V.addSelectedProductsToCart();
        Promise.resolve(r).catch(function () {}).then(function () { setTimeout(function () { busy = false; btn.classList.remove('is-busy'); resetAfterCart(); }, 1200); });
      } catch (e) { busy = false; btn.classList.remove('is-busy'); try { doc.dispatchEvent(new CustomEvent('greenic:add-fail')); } catch (e2) {} say('Das hat gerade nicht geklappt. Bitte noch einmal versuchen.'); }
    });
    /* v17.2 (Teil 9): Platzhalter-Daten je Produkt des Sets, Preis je Zeile mit Bundle-Rabatt ABGERUNDET wie render() */
    function setDetail() {
      var n = 1 + picked.length, pc = pct(n), items = [];
      var zeile = function (id, titel, bild, c) { return { id: String(id), titel: titel || '', bild: bild || '', menge: 1, preis: money(c - Math.floor(c * pc / 100)), abo: '' }; };
      items.push(zeile(PAGE.variantId, PAGE.title, PAGE.image, PAGE.price));
      picked.forEach(function (k) {
        var prod = poolItem(k); if (!prod) return;
        var v = prod.selected_variant || (prod.variants && prod.variants[0]) || {};
        items.push(zeile(v.id || k, prod.title, imgOf(prod), priceOf(prod)));
      });
      return { quelle: 'set', items: items };
    }

    function start(widget) {
      if (W) return;
      var view = widget.View || widget.view || null, step = null, p0 = {};
      try { step = widget.data.config.steps[0]; (step.products || []).forEach(function (p) { p0[pid(p.id)] = p; }); } catch (e) { step = null; }
      if (!view || !step || !p0[PAGE.id]) { return; }   // noch nicht geladen oder Seitenprodukt nicht im Pool: Block bleibt unsichtbar, später erneut versuchen
      W = widget; V = view; STEP = step; pool = p0;
      try { var tiers = W.data.config.discount && W.data.config.discount.tiers; if (tiers && tiers.length) { var tt2 = tiers.map(function (t) { return [parseInt(t.required_quantity || t.quantity || t.min_quantity, 10), parseFloat(t.discount_value || t.value || t.amount)]; }).filter(function (t) { return t[0] > 0 && !isNaN(t[1]); }).sort(function (a, b) { return a[0] - b[0]; }); if (tt2.length) TIERS = tt2; } } catch (e) {}
      // 15.10.: Altbestand früherer Seiten raus, Seitenprodukt rein (purge), dann zeichnen
      purge();
      // 15.10., 13:19: Rebuys Seitensperre bei vollem Bundle sofort wieder lösen (siehe unlock)
      try { new MutationObserver(unlock).observe(doc.body, { attributes: true, attributeFilter: ['class'] }); } catch (e) {}
      unlock();
      render(); reconcile(null);
      // Sicherheitsnetz, falls Rebuy sein gespeichertes Bundle erst nach dem Start zurückholt: einmal nachziehen
      setTimeout(function () {
        if (busy) return;
        var ids = bundleIds(), want = [PAGE.id].concat(picked);
        if (ids.length !== want.length || ids.some(function (k) { return want.indexOf(k) < 0; })) align();
      }, 1500);
      doc.addEventListener('rebuy.addProductToBundle', function () { setTimeout(syncFromRebuy, 50); });
      doc.addEventListener('rebuy.removeProductFromBundle', function () { setTimeout(syncFromRebuy, 50); });
      doc.addEventListener('rebuy:smartcart.hide', function () { setTimeout(syncFromRebuy, 100); });
    }
    function matches(w) { return w && String(w.id) === String(builderId); }
    doc.addEventListener('rebuy.ready', function (e) { if (matches(e.detail)) start(e.detail); });
    // Falls Rebuy schon fertig war, bevor dieses Skript lief
    (function poll(n) {
      if (W) return;
      var R = window.Rebuy; if (R && R.widgets && R.widgets.length) { var w = R.widgets.filter(matches)[0]; if (w && (w.View || w.view) && w.data && w.data.config) { start(w); if (W) return; } }
      if (n < 150) setTimeout(function () { poll(n + 1); }, 200);
    })(0);
    root.__gxSet = { get picked() { return picked.slice(); }, widget: function () { return W; }, suggest: suggest };
  }

  /* ---------- 5 Akkordeons G2 (15.10.2026, Vorschau B vom 14.10. 12:50 und 16:07) ----------
     Gilt für die Produkt-Akkordeons (Blocks collapsible_tab) und die FAQ-Sections (collapsible-tabs). Sleeks accordion-group
     (theme.js: eigener open-Setter mit Motion-Animation, schließt Geschwister sofort) wird am Summary-Klick abgefangen (Capture-Phase);
     Zustand läuft über das open-Attribut plus isOpen, damit Sleeks Getter stimmt. Höhen und Scroll laufen in EINER rAF-Schleife mit
     derselben Kurve (360 ms, cubic-bezier(.22,.61,.36,1)): die angetippte Zeile bleibt unter dem Finger; passt ihr Inhalt nicht in den
     Bildschirm, gleitet sie in derselben Bewegung so weit hoch wie nötig, höchstens bis unter den klebenden Header. Reduzierte Bewegung:
     ohne Animation. Nicht betroffen: Cross-Sell-Block (bleibt offen, Summary ohne Zeiger) und alle Akkordeons außerhalb der Produktseite. */
  function initAccordions() {
    if (doc.__gxAcc) return; doc.__gxAcc = true;
    var DUR = 360;
    function bez(x1, y1, x2, y2) {
      function a(t, p1, p2) { var m = 1 - t; return 3 * m * m * t * p1 + 3 * m * t * t * p2 + t * t * t; }
      return function (x) { var lo = 0, hi = 1, t; for (var i = 0; i < 22; i++) { t = (lo + hi) / 2; if (a(t, x1, x2) < x) lo = t; else hi = t; } return a(t, y1, y2); };
    }
    var ease = bez(.22, .61, .36, 1);
    var SEL = '.product__block--collapsible_tab details.accordion-details, .section--collapsible-tabs details.accordion-details';
    function groupOf(d) { return d.closest('collapsible-tabs, .accordion-parent') || d.parentElement; }
    function siblings(d) { var g = groupOf(d); return g ? [].slice.call(g.querySelectorAll('details.accordion-details')).filter(function (x) { return x.matches(SEL); }) : [d]; }
    function wrap(d) {
      var c = d.querySelector('.accordion-details__content'); if (!c) return null;
      if (c.parentNode.classList && c.parentNode.classList.contains('gxacc__anim')) return c.parentNode;
      var w = doc.createElement('div'); w.className = 'gxacc__anim'; c.parentNode.insertBefore(w, c); w.appendChild(c); return w;
    }
    function setOpen(d, v) {
      try { d.isOpen = v; } catch (e) {}
      if (v) d.setAttribute('open', ''); else d.removeAttribute('open');
      d.setAttribute('aria-expanded', v ? 'true' : 'false');
    }
    function stickyH() {
      var h = doc.querySelector('.header-section.header-sticky, .shopify-section-group-header-group.header-sticky, .section-header.header-sticky');
      if (!h) return 0;
      var r = h.getBoundingClientRect(); return r.bottom > 0 ? r.bottom : 0;
    }
    var running = false;
    function run(items, y0, y1) {
      items.forEach(function (it) { it.w.style.height = it.from + 'px'; it.w.style.opacity = it.from ? '1' : '0'; });
      function finish() { items.forEach(function (it) { it.done(); it.w.style.height = ''; it.w.style.opacity = ''; }); running = false; }
      if (calm) { finish(); if (y1 !== y0) window.scrollTo(0, y1); return; }
      running = true; var t0 = null;
      function frame(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / DUR), e = ease(p);
        items.forEach(function (it) { it.w.style.height = (it.from + (it.to - it.from) * e) + 'px'; it.w.style.opacity = (it.to ? e : 1 - e).toFixed(3); });
        if (y1 !== y0) window.scrollTo(0, y0 + (y1 - y0) * e);
        if (p < 1) requestAnimationFrame(frame); else finish();
      }
      requestAnimationFrame(frame);
    }
    doc.querySelectorAll(SEL).forEach(function (d) { wrap(d); if (d.hasAttribute('open')) d.setAttribute('aria-expanded', 'true'); });
    doc.addEventListener('click', function (e) {
      var t = e.target; if (!t || !t.closest) return;
      var sum = t.closest('summary'); if (!sum) return;
      var d = sum.parentElement; if (!d || !d.matches || !d.matches(SEL)) return;
      e.preventDefault(); e.stopPropagation();
      if (running) return;
      var items = [];
      if (d.hasAttribute('open')) {
        var w0 = wrap(d), h0 = w0 ? w0.getBoundingClientRect().height : 0;
        if (!w0) { setOpen(d, false); return; }
        items.push({ w: w0, from: h0, to: 0, done: function () { setOpen(d, false); } });
        run(items, 0, 0); return;
      }
      var y0 = window.scrollY || doc.documentElement.scrollTop, vh = window.innerHeight;
      var sr = sum.getBoundingClientRect(), hy0 = sr.top, hh = sr.height, above = 0;
      siblings(d).forEach(function (o) {
        if (o === d || !o.hasAttribute('open')) return;
        var ow = wrap(o); if (!ow) { setOpen(o, false); return; }
        var oh = ow.getBoundingClientRect().height;
        items.push({ w: ow, from: oh, to: 0, done: function () { setOpen(o, false); } });
        if (o.compareDocumentPosition(d) & Node.DOCUMENT_POSITION_FOLLOWING) above += oh;
      });
      var w = wrap(d); if (!w) { setOpen(d, true); return; }
      setOpen(d, true);
      var ch = w.scrollHeight;
      items.push({ w: w, from: 0, to: ch, done: function () {} });
      var top = stickyH() + 12, pad = 24, hy1 = hy0;
      if (hy0 + hh + ch + pad > vh) hy1 = Math.max(top, Math.min(hy0, vh - (hh + ch + pad)));
      var y1 = y0 + hy0 - above - hy1;
      var maxY = Math.max(0, doc.documentElement.scrollHeight - above + ch - vh);
      y1 = Math.round(Math.max(0, Math.min(y1, maxY)));
      run(items, y0, y1);
    }, true);
  }

  /* ---------- 6 Sprung-Button zurück zum Kaufbereich (sections/greenic-pdp-jump.liquid, 15.10.2026) ----------
     Eigene Animation (rAF, ease-in-out kubisch, 700 bis 1200 ms, 0,3 ms je px), kein behavior:smooth (Safari und Chrome spulen lange
     Strecken sonst ruckartig ab). Ziel: Oberkante des Glasblocks (.gxo) minus klebender Header minus 14 px, Landung mit dem Preis direkt
     unter dem Header. Ohne Glasblock: Preisblock. Reduzierte Bewegung: Sprung ohne Animation. */
  function initJump() {
    var btns = doc.querySelectorAll('[data-gx-jump]'); if (!btns.length) return;
    function target() { return doc.querySelector('[data-gx-buybox]') || doc.querySelector('.product__block--price') || doc.querySelector('product-info'); }
    function headerH() {
      var h = doc.querySelector('.header-section.header-sticky, .shopify-section-group-header-group.header-sticky, .section-header.header-sticky');
      if (!h) return 0; var r = h.getBoundingClientRect(); return r.bottom > 0 ? r.bottom : 0;
    }
    function glide(to) {
      var start = window.scrollY || doc.documentElement.scrollTop, dist = to - start;
      if (calm || Math.abs(dist) < 2) { window.scrollTo(0, to); return; }
      var dur = Math.min(1200, Math.max(700, Math.abs(dist) * .3)), t0 = performance.now();
      function ease(p) { return p < .5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2; }
      function step(now) { var p = Math.min(1, (now - t0) / dur); window.scrollTo(0, start + dist * ease(p)); if (p < 1) requestAnimationFrame(step); }
      requestAnimationFrame(step);
    }
    btns.forEach(function (b) {
      if (b.__gxInit) return; b.__gxInit = true;
      b.addEventListener('click', function () {
        var t = target(); if (!t) return;
        glide(Math.max(0, t.getBoundingClientRect().top + (window.scrollY || doc.documentElement.scrollTop) - headerH() - 14));
      });
    });
  }


  /* ---------- 7 Sheets Teilen und Frag uns direkt (Stufe 3, 15.10.2026; Vorschau B share_block.py, ask_block.py) ----------
     Rahmen und Sperre wie der Newsletter (greenic-newsletter.js): Sheet an den body hängen, body.gxsheet-open, Escape und Overlay schließen.
     Teilen: Link shop.url + product.url (snippets/gx-share.liquid). Link kopieren über die Zwischenablage (Rückfall execCommand), Kachel zeigt
     den Haken; Instagram nimmt keine Links an: Link kopieren, Hinweis, danach die App öffnen (instagram://app, am Desktop instagram.com);
     "Weitere Apps" nur, wenn der Browser navigator.share kann.
     Frag uns direkt: Shopifys Kontaktformular mit Spamschutz. hCaptcha hängt sich an das submit-Ereignis des Formulars und schickt danach mit
     HTMLFormElement.prototype.submit ab (geprüft 15.10.2026 am Skript storefront-forms-hcaptcha v1.5.3). Ein unsichtbarer Rahmen scheidet aus
     (Shopify sendet X-Frame-Options DENY, geprüft 15.10.2026). Deshalb: für genau dieses Formular wird der Aufruf auf fetch umgelenkt, mit allen
     Feldern samt Captcha-Antwort; ohne Captcha sendet das Script selbst. Erfolg = Umleitung auf contact_posted=true, dann Danke-Zustand ohne
     Neuladen. Prüfseite (/challenge) oder unbekannter Weg: normaler Versand, danach öffnet das Sheet im Danke-Zustand. */
  function initSheets() {
    var lastTrigger = null;
    function lock(on) {
      var any = on || !!doc.querySelector('.gxsheet.is-open');
      doc.body.classList.toggle('gxsheet-open', any);
    }
    function toBody(root, attr) {
      [].forEach.call(doc.querySelectorAll('body > [' + attr + ']'), function (o) { if (o !== root) o.parentNode.removeChild(o); });
      if (root.parentNode !== doc.body) doc.body.appendChild(root);
    }
    function openSheet(root, trigger, focusSel) {
      if (!root || root.classList.contains('is-open')) return;
      lastTrigger = trigger || null;
      if (root.__gxReset) root.__gxReset(true);
      root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false'); lock(true);
      if (focusSel) {
        var f = root.querySelector(focusSel);
        setTimeout(function () { if (f && root.classList.contains('is-open')) try { f.focus({ preventScroll: true }); } catch (e) {} }, 420);
      }
    }
    function closeSheet(root) {
      if (!root || !root.classList.contains('is-open')) return;
      root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true'); lock(false);
      if (lastTrigger && lastTrigger.focus) try { lastTrigger.focus({ preventScroll: true }); } catch (e) {}
      lastTrigger = null;
    }

    /* Teilen */
    var share = doc.querySelector('[data-gx-share]');
    if (share && !share.__gxInit) {
      share.__gxInit = true;
      toBody(share, 'data-gx-share');
      var url = share.getAttribute('data-url') || location.href.split('?')[0];
      var title = share.getAttribute('data-title') || doc.title;
      var text = share.getAttribute('data-text') || title;
      var media = share.getAttribute('data-media') || '';
      if (media.indexOf('//') === 0) media = 'https:' + media;
      var more = share.querySelector('[data-gxshare="native"]');
      if (more && navigator.share) more.hidden = false;
      var toast = share.querySelector('.gxshare__toast'), toastT = null;
      share.__gxReset = function () { [].forEach.call(share.querySelectorAll('.gxshare__item.is-done'), function (b) { b.classList.remove('is-done'); }); if (toast) { toast.classList.remove('is-on'); toast.textContent = ''; } };
      var E = encodeURIComponent;
      var targets = {
        whatsapp: function () { return 'https://wa.me/?text=' + E(text + '\n' + url); },
        sms: function () { return 'sms:?&body=' + E(text + ' ' + url); },
        mail: function () { return 'mailto:?subject=' + E(title) + '&body=' + E('Schau dir das mal an: ' + title + '\n' + url); },
        telegram: function () { return 'https://t.me/share/url?url=' + E(url) + '&text=' + E(text); },
        facebook: function () { return 'https://www.facebook.com/sharer/sharer.php?u=' + E(url); },
        pinterest: function () { return 'https://pinterest.com/pin/create/button/?url=' + E(url) + '&description=' + E(text) + (/^https:\/\//.test(media) ? '&media=' + E(media) : ''); },
        instagram: function () { return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? 'instagram://app' : 'https://www.instagram.com/'; }
      };
      function say(msg) { if (!toast) return; toast.textContent = msg; toast.classList.add('is-on'); clearTimeout(toastT); toastT = setTimeout(function () { toast.classList.remove('is-on'); }, 2600); }
      function go(href) {
        if (/^(sms|mailto|instagram):/.test(href)) { location.href = href; return; }
        /* ohne "noopener" im dritten Argument: damit liefert window.open null und der Rückfall würde die Seite selbst wegnavigieren */
        var w = window.open(href, '_blank');
        if (w) { try { w.opener = null; } catch (e) {} } else { location.href = href; }
      }
      function copy(btn, cb) {
        function ok() { btn.classList.add('is-done'); setTimeout(function () { btn.classList.remove('is-done'); }, 1800); if (cb) cb(); }
        function fallback() {
          var t = doc.createElement('textarea'); t.value = url; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.top = '0'; t.style.opacity = '0';
          doc.body.appendChild(t); t.select();
          var done = false; try { done = doc.execCommand('copy'); } catch (e) {}
          doc.body.removeChild(t);
          if (done) ok(); else say(url);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(ok, fallback); else fallback();
      }
      [].forEach.call(share.querySelectorAll('[data-gxshare]'), function (b) {
        b.addEventListener('click', function () {
          var k = b.getAttribute('data-gxshare');
          if (k === 'copy') { copy(b, function () { say('Link kopiert.'); }); return; }
          if (k === 'native') { if (navigator.share) navigator.share({ title: title, text: text, url: url }).catch(function () {}); return; }
          if (k === 'instagram') { copy(b, function () { say('Link kopiert. Füge ihn in deine Story oder Nachricht ein.'); setTimeout(function () { go(targets.instagram()); }, 700); }); return; }
          var t = targets[k]; if (t) go(t());
        });
      });
      [].forEach.call(share.querySelectorAll('[data-gxshare-close]'), function (b) { b.addEventListener('click', function () { closeSheet(share); }); });
    }

    /* Frag uns direkt */
    var ask = doc.querySelector('[data-gx-ask]');
    if (ask && !ask.__gxInit) {
      var form = ask.querySelector('[data-gx-ask-form]');
      if (form) {
        ask.__gxInit = true;
        toBody(ask, 'data-gx-ask');
        /* Formular-Versand umleiten: hCaptcha ruft nach der Prüfung HTMLFormElement.prototype.submit auf; für dieses Formular (und nur,
           wenn wir es scharf gestellt haben) läuft stattdessen der fetch-Versand mit allen Feldern samt Captcha-Antwort. Alle anderen
           Formulare gehen unverändert an die ursprüngliche Funktion. Lädt das Captcha-Skript vor dieser Stelle und hat die Funktion schon
           gemerkt, geht das Formular normal ab (Seite lädt neu, das Sheet zeigt danach den Danke-Zustand). */
        if (!window.__gxNativeSubmit) {
          window.__gxNativeSubmit = HTMLFormElement.prototype.submit;
          HTMLFormElement.prototype.submit = function () {
            if (this && this.__gxArmed && typeof this.__gxAjax === 'function') return this.__gxAjax();
            return window.__gxNativeSubmit.apply(this, arguments);
          };
        }
        var done = ask.querySelector('.gxask__done'), err = ask.querySelector('.gxask__error'), btn = form.querySelector('[type="submit"]');
        var nameOut = ask.querySelector('.gxask__name'), errText = err ? err.textContent : '';
        var sending = false, guard = null;
        function first() { var n = form.querySelector('[name="contact[name]"]'); return n ? (n.value || '').trim().split(/\s+/)[0] : ''; }
        function remember(name) { try { if (name) sessionStorage.setItem('gxAskName', name); else sessionStorage.removeItem('gxAskName'); } catch (e) {} }
        function showDone(name) {
          if (nameOut) nameOut.textContent = name ? ', ' + name : ' dir';
          form.hidden = true; if (done) done.hidden = false; ask.classList.add('is-done');
          var g = done ? done.querySelector('[data-gxask-close]') : null;
          if (g) setTimeout(function () { try { g.focus({ preventScroll: true }); } catch (e) {} }, 60);
        }
        function idle() { sending = false; form.__gxArmed = false; clearTimeout(guard); if (btn) btn.disabled = false; form.removeAttribute('aria-busy'); }
        function showError(msg) { if (err) { err.textContent = msg || errText; err.hidden = false; } }
        ask.__gxReset = function (clear) {
          if (sending) return;
          form.hidden = false; if (done) done.hidden = true; ask.classList.remove('is-done');
          if (err) { err.hidden = true; err.textContent = errText; }
          if (clear) { var se = form.querySelector('.gxask__errors'); if (se) se.parentNode.removeChild(se); }
        };
        /* Versand per fetch (urlencoded wie ein normales Formular). Shopify leitet nach Erfolg auf ...?contact_posted=true um; verlangt es
           die Prüfseite (/challenge), geht das Formular normal ab, der Kunde sieht die Prüfung und kommt danach mit Danke-Zustand zurück. */
        form.__gxAjax = function () {
          form.__gxArmed = false;
          var name = first(), body;
          try { body = new URLSearchParams(new FormData(form)); } catch (e) { window.__gxNativeSubmit.call(form); return; }
          fetch((form.getAttribute('action') || '/contact').split('#')[0], { method: 'POST', body: body, credentials: 'same-origin', redirect: 'follow', headers: { 'Accept': 'text/html' } })
            .then(function (r) {
              var u = r.url || '';
              if (/[?&]contact_posted=true/.test(u)) { idle(); remember(''); form.reset(); showDone(name); return; }
              if (/\/challenge(?:[\/?#]|$)/.test(u)) { idle(); remember(name); window.__gxNativeSubmit.call(form); return; }
              return r.text().then(function (html) {
                var msg = '';
                try { var d = new DOMParser().parseFromString(html, 'text/html'), e = d.querySelector('.gxask__errors'); if (e) msg = e.textContent.replace(/\s+/g, ' ').trim(); } catch (x) {}
                idle(); remember(''); showError(msg);
              });
            })
            .catch(function () { idle(); remember(''); showError(); });
        };
        /* Capture-Phase am Dokument (vor hCaptcha am Formular): ungültig = anhalten; gültig = scharf stellen und durchlassen.
           Nach dem Formular (Bubble-Phase am Dokument): hat niemand den Versand übernommen (kein Captcha), selbst per fetch senden. */
        doc.addEventListener('submit', function (e) {
          if (e.target !== form) return;
          if (sending || !form.reportValidity()) { e.preventDefault(); e.stopPropagation(); return; }
          sending = true; form.__gxArmed = true; remember(first());
          if (btn) btn.disabled = true; form.setAttribute('aria-busy', 'true');
          if (err) { err.hidden = true; err.textContent = errText; }
          clearTimeout(guard);
          guard = setTimeout(function () { if (sending) idle(); }, 45000);   // Captcha abgebrochen: Button wieder frei, ohne Fehlermeldung
        }, true);
        doc.addEventListener('submit', function (e) {
          if (e.target !== form || !form.__gxArmed || e.defaultPrevented) return;
          e.preventDefault();
          form.__gxAjax();
        }, false);
        [].forEach.call(ask.querySelectorAll('[data-gxask-close]'), function (b) { b.addEventListener('click', function () { closeSheet(ask); }); });
        /* Rückkehr nach normalem Versand (Rückfall, Prüfseite): Danke-Zustand oder Shopify-Fehler im Sheet zeigen, Adresszeile aufräumen */
        var posted = ask.querySelector('[data-gx-ask-posted]') || /[?&]contact_posted=true/.test(location.search);
        var hasErr = ask.querySelector('.gxask__errors');
        if (posted || hasErr) {
          var nm = ''; try { nm = sessionStorage.getItem('gxAskName') || ''; sessionStorage.removeItem('gxAskName'); } catch (e) {}
          ask.classList.add('is-open'); ask.setAttribute('aria-hidden', 'false'); lock(true);
          if (posted) showDone(nm);
          try { var u = new URL(location.href); u.searchParams.delete('contact_posted'); if (u.hash === '#gxask-form') u.hash = ''; history.replaceState(history.state, '', u.toString()); } catch (e) {}
        }
      }
    }

    /* Ein Klick- und Tasten-Handler für beide Buttons (bleibt auch nach Neuladen einer Section im Theme-Editor gültig) */
    if (!doc.__gxSheets) {
      doc.__gxSheets = true;
      doc.addEventListener('click', function (e) {
        var t = e.target && e.target.closest ? e.target.closest('.gxshare-open, .gxask-open') : null;
        if (!t) return;
        var isShare = t.classList.contains('gxshare-open');
        var root = doc.querySelector(isShare ? '[data-gx-share]' : '[data-gx-ask]');
        if (!root) return;
        e.preventDefault();
        openSheet(root, t, isShare ? null : 'input[name="contact[name]"]');
      });
      doc.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        [].forEach.call(doc.querySelectorAll('[data-gx-share].is-open, [data-gx-ask].is-open'), closeSheet);
      });
    }
  }

  /* ---------- 8 Blätter per Wischen schließen (15.10.2026, Constantin 19:01: "erster Impuls wäre wegwischen wie auf dem iPhone") ----------
     Gilt für alle Blätter von unten: Teilen, Frag uns direkt, Newsletter (.gxsheet__sheet) und das Blatt der Kaufleiste (.gxsb__sheet),
     nur unter 768 px (darüber sind die Sheets Fenster in der Mitte). Verhalten wie bei iOS:
     - Ziehen nach unten nimmt das Blatt mit dem Finger mit, der Hintergrund hellt auf. Ist der Inhalt gescrollt, scrollt zuerst der Inhalt.
     - Loslassen: weiter als 28% der Blatthöhe (höchstens 140 px) oder schneller Wisch (über 0,55 px/ms) schließt, sonst federt es zurück;
       wer am Ende wieder nach oben zieht, behält das Blatt (wie bei iOS).
     - Geschlossen wird über den Schließen-Knopf des Blatts, damit Sperre, Fokus und Kaufauswahl genau wie beim X zurückgehen.
     - Waagerechte Gesten (Schalter Mengenrabatt/Abo) und Gesten, die in einem Textfeld beginnen, bleiben unberührt; Tippen wirkt wie bisher. */
  function initSwipe() {
    var small = window.matchMedia ? window.matchMedia('(max-width: 767.98px)') : null;
    var TEXT = 'input:not([type="radio"]):not([type="checkbox"]):not([type="button"]):not([type="submit"]), textarea, select, [contenteditable="true"]';
    function attach(sheet) {
      if (!sheet || sheet.__gxSwipe) return;
      var isGx = sheet.classList.contains('gxsheet__sheet');
      var root = isGx ? sheet.closest('.gxsheet') : (sheet.closest('#GreenicStickyBuy') || sheet.parentNode);
      if (!root) return;
      sheet.__gxSwipe = true;
      var dim = root.querySelector(isGx ? '.gxsheet__overlay' : '.gxsb-dim');
      var state = 0, x0 = 0, y0 = 0, dy = 0, h = 1, pts = [], snapT = null;
      function isOpen() { return isGx ? root.classList.contains('is-open') : sheet.classList.contains('is-open'); }
      function setY(y) {
        sheet.style.transform = 'translate3d(0,' + y + 'px,0)';
        if (dim) dim.style.opacity = String(Math.max(0, 1 - Math.max(y, 0) / h));
      }
      function clearInline() {
        sheet.style.transition = ''; sheet.style.transform = '';
        if (dim) { dim.style.transition = ''; dim.style.opacity = ''; }
      }
      function release(allowClose) {
        /* Tempo der letzten 80 ms (mindestens 16 ms gerechnet, damit zwei dicht aufeinanderfolgende Ereignisse keinen Ausreißer liefern) */
        var v = 0;
        if (pts.length > 1) { var a = pts[0], b = pts[pts.length - 1]; v = (b[1] - a[1]) / Math.max(b[0] - a[0], 16); }
        /* weit genug gezogen und nicht gerade zurück nach oben unterwegs, oder schneller Wisch nach unten */
        if (allowClose && ((dy > Math.min(140, h * 0.28) && v > -0.2) || (v > 0.55 && dy > 20))) {
          /* Inline-Werte und Klasse im selben Durchgang ändern: die CSS-Schließanimation startet an der Fingerposition */
          var btn = root.querySelector(isGx ? '.gxsheet__close' : '.gxsb__close');
          clearInline();
          if (btn) btn.click(); else root.classList.remove('is-open');
          return;
        }
        if (calm) { clearInline(); return; }
        sheet.style.transition = 'transform .28s cubic-bezier(.2,.8,.25,1)';
        if (dim) dim.style.transition = 'opacity .28s ease';
        sheet.style.transform = ''; if (dim) dim.style.opacity = '';
        snapT = setTimeout(function () { snapT = null; sheet.style.transition = ''; if (dim) dim.style.transition = ''; }, 320);
      }
      sheet.addEventListener('touchstart', function (e) {
        state = 0;
        if (small && !small.matches) return;
        if (!isOpen() || e.touches.length !== 1) return;
        if (e.target && e.target.closest && e.target.closest(TEXT)) return;
        if (snapT) { clearTimeout(snapT); snapT = null; }
        state = 1; x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; dy = 0; pts = [];
        h = sheet.getBoundingClientRect().height || 1;
      }, { passive: true });
      sheet.addEventListener('touchmove', function (e) {
        if (state < 1) return;
        if (e.touches.length !== 1) { if (state === 2) release(false); state = 0; return; }
        var x = e.touches[0].clientX, y = e.touches[0].clientY, mx = x - x0, my = y - y0;
        if (state === 1) {
          if (Math.abs(mx) < 4 && Math.abs(my) < 4) return;
          /* waagerecht, nach oben oder Inhalt gescrollt: die Geste gehört dem Inhalt */
          if (Math.abs(mx) > Math.abs(my) || my < 0 || sheet.scrollTop > 0) { state = 0; return; }
          /* ab hier gehört die Geste dem Blatt; der angefasste Punkt bleibt unter dem Finger */
          state = 2;
          sheet.style.transition = 'none'; if (dim) dim.style.transition = 'none';
        }
        if (e.cancelable) e.preventDefault();
        dy = my;
        setY(dy > 0 ? dy : Math.max(dy / 4, -12));
        var now = e.timeStamp || Date.now();
        pts.push([now, y]);
        while (pts.length > 2 && now - pts[0][0] > 80) pts.shift();
      }, { passive: false });
      function end(e) {
        if (state !== 2) { state = 0; return; }
        state = 0;
        release(e.type === 'touchend');
      }
      sheet.addEventListener('touchend', end, { passive: true });
      sheet.addEventListener('touchcancel', end, { passive: true });
    }
    [].forEach.call(doc.querySelectorAll('.gxsheet__sheet, .gxsb__sheet'), attach);
  }
  function swipe() { try { initSwipe(); } catch (e) { if (window.console) console.warn('[Greenic] Wischen:', e); } }

  function boot() {
    initSofort();   // v17.2: vor allem anderen, damit der Tipp auch bei einem Fehler weiter unten gemeldet wird
    initShip();
    initAbout();
    initSet();
    initAccordions();
    initJump();
    if (window.GreenicBuy) initSticky();
    else {
      doc.addEventListener('greenic:buy-ready', initSticky, { once: true });
      setTimeout(initSticky, 1500);   // Produkte ohne Kaufauswahl (Bundles): Leiste trotzdem
    }
    sheets();   // zuletzt und abgesichert: ein Fehler in den Sheets darf Kaufleiste und Kaufauswahl nicht mitnehmen
    swipe();
  }
  function sheets() { try { initSheets(); } catch (e) { if (window.console) console.warn('[Greenic] Sheets:', e); } }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
  doc.addEventListener('shopify:section:load', function () { initAbout(); initSticky(); initSet(); initJump(); sheets(); swipe(); });
})();
